import { TableCell, Typography } from '@mui/material'
import React from 'react'
import { useResponsiveTypography } from '../../../../utility/responsiveTypography'

const TableCellHeading = ({ isHidden, width, children }) => {
  const { previewText } = useResponsiveTypography()
  return (
    <TableCell
      sx={{
        minWidth: `${width}rem`,
        display: isHidden ? 'none' : '',
        backgroundColor: 'white',
      }}
    >
      <div>
        <Typography
          sx={{
            textAlign: 'left',
            fontSize: previewText,
            fontWeight: 'bold',
          }}
          variant="caption"
        >
          {children}
        </Typography>
      </div>
    </TableCell>
  )
}

export default TableCellHeading
